exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-control-lg.autocomplete__box {\n  height: calc(2.64062rem + 2px);\n}\n.form-control-lg > .autocomplete__icon {\n  height: calc(2.64062rem - 12px);\n  width: 20px;\n}\n.list-group-item.active > a {\n  color: #fff;\n}\n.vdp-datepicker__clear-button:after {\n  content: 'Clear Date';\n  padding: 5px;\n  color: #198eb7;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/t1/PersonForm.vue
// module id = 1653
// module chunks = 0